import React, { useState } from 'react';
import { TextField, InputAdornment, Typography, IconButton } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ErrorIcon from '@mui/icons-material/Error';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import dayjs from 'dayjs';
import palette from 'src/theme/palette';

const DateField = ({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  required,
  disabled,
  backgroundColor,
  fontFamily,
  fontSize,
  height,
  color,
  labelColor,
  width,
  labelFontMedium
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ marginBottom: error ? '0.2rem' : '1rem', width: width || '100%' }}>
      {/* Top Label */}
      {label && (
        <Typography
          sx={{
            fontSize: 12,
            marginBottom: '4px',
            fontFamily: labelFontMedium ? 'poppinsMedium' : 'poppinsRegular',
            color: labelColor ? labelColor : '#1a1a1a'
          }}
        >
          {label}
        </Typography>
      )}

      <DatePicker
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={value ? dayjs(value) : null}
        onChange={(newValue) => {
          onChange?.({
            target: {
              name,
              value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
            }
          });
        }}
        disabled={disabled}
        slotProps={{
          textField: {
            fullWidth: true, // ✅ full width
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  {/* Calendar Icon */}
                  <IconButton onClick={() => setOpen(true)} size="small">
                    <CalendarTodayIcon sx={{ fontSize: 18, color: '#555' }} />
                  </IconButton>

                  {/* Error Icon */}
                  {error && <ErrorIcon color="error" sx={{ fontSize: 20, ml: 0.5 }} />}
                </InputAdornment>
              )
            },
            sx: {
              '& .MuiOutlinedInput-root': {
                borderRadius: '6px',
                width: '100%',
                fontFamily: fontFamily ? fontFamily : 'poppinsRegular',
                fontSize: fontSize ? fontSize : 12,
                color: color ? color : palette.primary.titledark,
                height: height ? height : 40,
                backgroundColor: backgroundColor || 'transparent',
                '& fieldset': {
                  borderColor: error
                    ? palette.primary.inputbordererror
                    : palette.primary.inputborder,
                  borderWidth: '1.5px'
                },
                '&:hover fieldset': {
                  borderColor: error
                    ? palette.primary.inputbordererror
                    : palette.primary.inputborder
                },
                '&.Mui-focused fieldset': {
                  borderColor: error
                    ? palette.primary.inputbordererror
                    : palette.primary.inputborder,
                  borderWidth: '1.5px'
                }
              }
            }
          }
        }}
      />
    </div>
  );
};

export default DateField;
